import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { contractsAutoCompleteInput$, contractsAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const ContractsAutoSuggest = renderAutoSuggestWithOptions(
   contractsAutoCompleteObservable$,
   contractsAutoCompleteInput$,
);

ContractsAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Contracts...',
};

export default ContractsAutoSuggest;
